module.exports = __webpack_public_path__ + "media/images/work_articles_input_post_icon-1431e65230dac28daed5ff025dd00de4.png";